import {Link} from "react-router-dom";
const NewsCell =({params})=> {
  let tousen = params.tousen;
  if(!tousen && params.tags && params.tags.nodes && params.tags.nodes.length > 0) {
    params.tags.nodes.map(res=> {
      if(res.name && res.name.indexOf('当選') !== -1) tousen = true;
    })
  }

  return (
    <div className="event_item_info">
      <p className="title date_wrapper">
        {params.subtitle && <span className="type text-lg news">{params.subtitle}</span>}
        {params.time && <span className="type news">{params.time}</span>}
        {(params.tousen || tousen) && <Link to="/tousen"><span className="type tousen">当選発表</span></Link>}
        {params.type && <span className="type news">{params.type}</span>}
        {params.title}
      </p>
    </div>
  )
}

export default NewsCell
